import { z } from 'zod';
import { documentSchema } from '../document';
import { momentSchema } from '../momentSchema';
import { components } from 'lib/api/firebase/apis/api-config/api-paths-v2.ts.types';

export const assessmentTypeSchema = z.enum(['baseline', 'post-injury']);
export type AssessmentType = z.infer<typeof assessmentTypeSchema>;
export const assessmentIndexStatus = z.enum([
  'pending',
  'expired',
  'started',
  'submitted',
  'completed',
  'cancelled'
]);
export type AssessmentIndexStatusType = z.infer<typeof assessmentIndexStatus>;

export const patientAssessmentOverviewSchema = documentSchema.and(
  z.object({
    lastAssessmentDate: momentSchema.nullable(),
    nextAssessmentType: assessmentTypeSchema
  })
);

export interface PatientAssessmentOverview
  extends z.infer<typeof patientAssessmentOverviewSchema> {}

type S = components['schemas']['AssessmentIndexEntry'];
export interface AssessmentIndexEntry extends S {}
